module.exports = __webpack_public_path__ + "assets/img/mecha-btn-8537be64.png";